import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTreatmentReport, type ApiResponse } from '@/services/main/treatmentReport';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';

/**
 * Delete a treatment report from the list page.
 * On success: invalidates list query so the table refetches.
 */
export function useDeleteTreatmentReport(patientId?: string) {
  const queryClient = useQueryClient();
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();

  return useMutation({
    mutationFn: async (id: number) => {
      try {
        const res = await deleteTreatmentReport(
          tenant || '',
          clinicNumber || '',
          patientId || '',
          String(id),
          serviceType
        );
        return res;
      } catch (error: any) {
        if (error?.response?.status === 404) {
          return { success: true, data: null, message: '削除が正常に終了しました。' } as ApiResponse<unknown>;
        }
        throw error;
      }
    },
    onSuccess: () => {
      if (tenant && clinicNumber && patientId) {
        queryClient.invalidateQueries({
          queryKey: ['treatment-reports', 'list', tenant, clinicNumber, patientId],
          refetchType: 'active',
        });
        queryClient.invalidateQueries({
          queryKey: ['rezept', 'list', tenant, clinicNumber],
        });
      }
    },
  });
}
